/*
 *  Developed by CQ Inversiones SAS. Copyright (c) 2024. All rights reserved.
 *  Desarrollado por CQ Inversiones SAS. Copyright (c) 2024. Todos los derechos reservados.
 */

/*
 * Project:      mkad-frontend
 * Developed by: Juan David Pelaez
 * Date:         21/04/24 - 19:13:42
 * Module name:  general.constant
 * File name:    general.constant.ts
 * IDE:          WebStorm
 */

export const NO_INDEX_FIND = -1;
export const THOUSAND = 1000
